import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';

function AnalysisExportStatusBlock({ parentState }) {

    const api = parentState.helper.api;

    const num_bildungsgaenge = api.reply_data.length;
    const num_klassen = api.reply_data.reduce((acc, bg) => acc + bg.classes.length, 0);
    const num_faecher = api.reply_data.reduce((acc, bg) => acc + bg.classes.reduce((acc, sClass) => acc + sClass.lessons.length, 0), 0);

    useEffect(() => {
        // console.log("API:", api);
    }, [parentState]);

    return (
        <>
            <div>
                {/* <Row>
                    <Col>Webdatenbank erreichbar</div><Col>
                        {(api.connected) &&
                            <>
                                Ja (zuletzt: {api.last_connect})
                            </>
                        }
                        {(!api.connected) &&
                            <>
                                Keine valide Verbindung
                            </>
                        }

                    </div>
                </div> */}
                <Row>
                    <Col>Verbindung hergestellt</Col>
                    <Col>{api.connected ? "Ja" : "Nein"}, mit Status {api.reply_status_code}</Col>
                </Row>
                {/* <Row>
                    <Col>Status</Col>
                    <Col>{api.reply_status_code}</Col>
                </Row> */}
                <Row>
                    <Col>Letzte Verbindung</Col>
                    <Col>{api.last_connect ? api.last_connect : "Bisher keine Verbindung"}</Col>
                </Row>
                <Row>
                    <Col>... mit DGSE DiSch</Col><Col>{api.disch}</Col>
                </Row>
                <Row>
                    <Col>... und Schuljahr</Col><Col>{api.school_year_name}</Col>
                </Row>
                
                <Row className="mt-3">
                    <Col as="h5">Empfangene Schuldaten</Col>
                </Row>

                <Row>
                    <Col>Bildungsgänge</Col><Col>{num_bildungsgaenge}</Col>
                </Row>
                <Row>
                    <Col>... mit Klassen</Col><Col>{num_klassen}</Col>
                </Row>
                <Row>
                    <Col>... und Fächern</Col><Col>{num_faecher}</Col>
                </Row>

            </div>
        </>
    );
}

export default AnalysisExportStatusBlock;
